import { render } from "./WhatsAppWidget.vue?vue&type=template&id=37c73d13"
import script from "./WhatsAppWidget.js?vue&type=script&lang=js&external"
export * from "./WhatsAppWidget.js?vue&type=script&lang=js&external"

import "./WhatsAppWidget.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__